<button (click)="onButtonClick()">
  <img [uiTooltipTitle]="'get_suggested_tags_for_this_okr' | localize" uiTooltipPlacement="right" src="/dist/img/suggest-logo.svg" alt="Quantive suggest logo" ui-tooltip />
</button>
